import React from 'react';
import Popup from '../../ui/Popup';
import { styled } from 'linaria/react';

const VideoWrapper = styled('div')`
  height: 100%;
  max-height: 95vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  iframe {
    display: block;
    margin: 0 auto;
  }
`;

const VideoPopup = ({ videoSrc, setActiveImage }) => {
  return (
    <Popup
      isOpen={true}
      closePopup={() => setActiveImage(false)}
      className="image"
    >
      <VideoWrapper>
        <iframe
          title="product-video"
          width="1200"
          height="700"
          src={videoSrc}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        />
      </VideoWrapper>
    </Popup>
  );
};

export default VideoPopup;
